import type { QuickBooksConnectLink, QuickBooksConnectLinkPerson } from '../../../data/ServerApiClient'

/**
 * Pure helpers for the standing QuickBooks connect link, kept out of the
 * component so they can be tested without a DOM.
 */

/** A draft email to the company's QuickBooks admin. Opens in the reader's own
 * mail app; FuseGrid sends nothing. */
export function connectLinkMailto(link: Pick<QuickBooksConnectLink, 'url'>, companyLabel: string, reconnect = false): string {
  const company = companyLabel.trim() || 'your company'
  const subject = reconnect
    ? `Please reconnect ${company}'s QuickBooks to FuseGrid`
    : `Please connect ${company}'s QuickBooks to FuseGrid`
  const body = [
    'Hi,',
    '',
    reconnect
      ? `Could you reconnect ${company}'s QuickBooks to FuseGrid? The connection needs to be authorized again.`
      : `Could you connect ${company}'s QuickBooks to FuseGrid?`,
    '',
    'Open this link, click the QuickBooks button, sign in with a QuickBooks login that administers the company, and pick the company from the list:',
    '',
    link.url,
    '',
    "You don't need a FuseGrid account, and the link doesn't expire.",
    '',
    'Thanks!',
  ].join('\n')
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

/** How a requester reads in a picker: their name with the email that
 * identifies them, or the email alone before they have set a name. */
export function connectLinkPersonLabel(person: Pick<QuickBooksConnectLinkPerson, 'email' | 'full_name'>): string {
  const name = String(person.full_name || '').trim()
  const email = String(person.email || '').trim()
  if (name && email) return `${name} (${email})`
  return name || email || 'Unknown person'
}

/** Loose shape check before asking the server to add someone; the server
 * normalizes and decides. */
export function looksLikeEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}
